import { render } from "./TextImageItem.vue?vue&type=template&id=7e1a0460"
import script from "./TextImageItem.vue?vue&type=script&lang=js"
export * from "./TextImageItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__